<ng-container *transloco="let t">
  <app-page-template>
    <div class="container">
      <div class="pt-32 mb-4">
        <div class="d-flex align-items-center gap-2 mb-3">
          @if(league?.imageIcon) {
            <img src="{{league?.imageIcon || ''}}" class="league-logo" alt="League Logo">
          }
            <div class="fw-semibold fs-32-24">
              <app-language-output [hrLabel]="league?.name" [srLabel]="league?.nameSr"
                                   [enLabel]="league?.nameEng" [itLabel]="league?.nameIta"
                                   [siLabel]="league?.nameSlo" [bsLabel]="league?.nameBs"
                                   [languages]="languages" [showAsInnerHtml]="true"
                                   [defaultLabel]="t('app.common.league')"
                                   [isUpperCase]="true"
              />
            </div>

            <!--<p class="fs-14-16 fw-400 text-uppercase">{{ t('league.details.powered.by') }}</p>-->
        </div>

        <div class="d-flex flex-column gap-1 league-section-mobile">
          <div class="d-flex justify-content-start align-items-center gap-1 fw-400">
            <span class="tag mint bold"> {{ t('league.status.' + league?.status) | uppercase}}
            </span>
            @if (league?.sportId) {
            <i class="bi bi-dot"></i>
            <span class="color-slate-800"> {{ t("app.common.sports." + league?.sportId) }} </span>
            }
            @if (league?.countries?.length) {
            <i class="bi bi-dot"></i>
              <app-location-display [cssClass]="'color-slate-800 fs-16'" [countries]="league?.countries" [showList]="true" [showIcon]="false"/>
            }
          </div>

          <div class="d-flex justify-content-start align-items-center gap-1 fw-400 color-slate-800">
            @if (league?.start && league?.end) {
              <app-event-date-display [start]="league!.start" [end]="league!.end" [displayDay]="false"/>
            }
            <i class="bi bi-dot"></i>
            <p>
              {{ t('app.common.events.count.' +
                    ((leagueEvents?.total ?? 0) > 3 ? 'other' : leagueEvents?.total),
                    { count: leagueEvents?.total }) }}
            </p>
          </div>
        </div>


      </div>

      <app-nav-tabs [useRouterOutlet]="true" [queryParamsHandling]="useSlugRoutes ? undefined : 'preserve'" [tabCssClass]="'public'">
        <app-nav-tab [title]="t('league.tab.overview')" [itemId]="1" [route]="tabOverview">
        </app-nav-tab>

        <app-nav-tab [title]="t('league.tab.league.events')" [itemId]="2" [route]="tabLeagueEvents">
        </app-nav-tab>

        <app-nav-tab [title]="t('league.tab.standings')" [itemId]="3" [route]="tabStandings">
        </app-nav-tab>

        <app-nav-tab [title]="t('league.tab.info')" [itemId]="4" [route]="tabInfo">
        </app-nav-tab>

        <!--<app-nav-tab [title]="t('league.tab.feeds')" [itemId]="5" [route]="tabFeeds">
        </app-nav-tab>-->
        <!--<div class="d-none d-xxl-flex">
          <app-share-cta [leagueItem]="league"/>
        </div>-->
      </app-nav-tabs>
    </div>
  </app-page-template>

  <ng-template #leagueNameShare>
    <div class="d-flex">
      <h2 class="me-3">{{ league?.name }}</h2>
      <div class="d-flex action-btn-wrapper">
        <img src="assets/icons/icons-alt/share-alt.svg" alt="Podijeli">
      </div>
    </div>
  </ng-template>

</ng-container>
